import { RefObject, useLayoutEffect, useState } from 'react';

export const useElementHeight = (
  HTMLElement: `#${string}` | `[data-testid=${string}]` | RefObject<HTMLElement | null>,
  defaultHeight = 0,
) => {
  const [elementHeight, setElementHeight] = useState(defaultHeight);

  useLayoutEffect(() => {
    switch (typeof HTMLElement) {
      case 'string': {
        const element = document.querySelector(HTMLElement);
        if (element) {
          setElementHeight(element.clientHeight);
        }
        break;
      }
      default: {
        setElementHeight(HTMLElement.current?.clientHeight || defaultHeight);
        break;
      }
    }
  }, [HTMLElement, defaultHeight]);

  return elementHeight;
};
